import currencyUnitTypeSelector from './currency-unit-type.js'

export default [currencyUnitTypeSelector]
